module.exports = __webpack_public_path__ + "static/media/country_dz.5f9d1f39.webp";